(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};

    // resources namespace
    if (!sm.resources) {
        jQuery.extend(sm, { resources: {} });
    }

    // site namespace type
    jQuery.extend(sm.resources, { portalResource: {} });

    // resource value retrieval function
    jQuery.extend(true, sm.resources.portalResource, {
        getValue: function (key) {
            var retValue = key;
            try {
                var value = eval('sm.resources.portalResource.' + key);
                if (!sm.portal.utility.isNullOrEmpty(value)) {
                    retValue = value;
                }
            } catch (e) { }
            return retValue;
        }
    });

    jQuery.extend(true, sm.resources.portalResource, {
        // <Individual Values> - This needs to stay here for localization management!!!!
        Absent: "Absent",
        Academic: "Academic",
        AcademicAttendanceReason: 'How did you hear about the course?',
        AcademicDetails: "Academic Details",
        AcademicGoal: "Academic Goal",
        AcademicGoals: "Academic Goals",
        AcademicLevel: "Academic Level",
        AcademicPeriod: "Academic Period",
        AcademicProgram: "Academic Program",
        AcademicTerm: 'Academic Term',
        Accept: "Accept",
        Accepted: "Accepted",
        Accessibility: "Accessibility",
        AccessibilityNeeds: "Accessibility Needs",
        AccessibilityNeedType: "Accessibility Need Type",
        AccessibilityNeedsInfoText: 'The College is committed to supporting students with disabilities and learning differences. In order to support you and your studies it is important for us to be aware of any learning difference or disability that may apply to you. So that we may assist your learning experience if you have a learning difference or disability, please email any relevant details to admissions@rca.ac.uk. This will be treated in confidence. If you would prefer to discuss your situation confidentially with a member of staff, please contact the <a href="https://www.rca.ac.uk/studying-at-the-rca/support/student-support/" target="_blank">Student Support Office</a> Disclosure of this information will not jeopardize your application.',
        Account: "Account",
        AccountInformation: "Account Information",
        AccountMemberships: "Account Memberships",
        AccountStatus: "Account Status",
        AccountApoiText1: "Welcome to our direct applicant portal to complete your application for:",
	    AccountApoiText2: "You may change your programme of study when completing your application if you wish.",
        AccountText1: "Please use the form below to submit the information we need to process your application. Your information is saved as you go so you can come back to your application at your convenience.",
	    AccountText2: "You will find it useful to have certain information to hand e.g. qualifications, employment details and supporting documents ready to upload, e.g. your personal statement.",
	    AccountText3: 'Please refer to the <a href="/guidelines-for-applicants" target="_blank">guidelines for applicants (Opens in new tab)</a> for guidance on completing your application.',
        AccountType: "Account Type",
        Action: "Action",
        ActionSuccessfull: "Your Actions Completed Successfully",
        Actions: "Actions",
        ACTScores: "ACT Scores",
        ACTTestDate: "ACT Test Date",
        Add: "Add",
        AddToWaitlist: "Add to Waitlist",
        AddDisability: 'Add Disability',
        AddAccessibilityNeed: "Add Accessibility Need",
        AddAccessibilityNeeds: "Add Accessibility Needs",
        AddACTScore: "Add ACT Score",
        AddCollege: "Add College",
        AddEmployer: "Add Employer",
        AddEmployment: "Add Employment",
        AddFile: "Add File",
        AddGMATScore: "Add GMAT Score",
        AddGREScore: "Add GRE Score",
        AddHighSchool: "Add High School",
        Adding: "Adding...",
        AdditionalInformation: "Additional Information",
        AdditionalFooterText: 'View Selected Courses Below',
        AddLanguage: "Add Language",
        AddLanguageAssessment: 'Add Language Assessment',
        AddPraxisIIScore: "Add PRAXIS II Score",
        AdmissionsDocument: 'Admissions Requirements',
        AddPraxisScore: "Add PRAXIS Score ",
        AddQualification: "Add Qualification",
        Address: "Address",
        Addresses: "Addresses",
        AddressFormat: "Address Format",
        AddressInformation: "Address Information",
        AddressLine1: "Address Line 1",
        AddressLine2: "Address Line 2",
        AddressTiming: "Address Timing",
        AddSATScore: "Add SAT Score",        
        AddSpecialism: "Add Specialism",
        AddSubScores: "Add Sub-Scores",
        AddTOEFLScore: "Add TOEFL Score",
        AdmissionsApplicationForm: "Admissions Application Form",
        AdmissionsBackgroundProcessing: "We are still processing your application, please refresh page after few seconds...",
        AdmissionsBackgroundProcessingError: "Error(s) occurred during the Apply Now process. Please wait until errors are fixed or contact the administrator directly.",
        AdmissionsBackgroundProcessingText: "We are still processing your application, please refresh the page after a couple of minutes",
        AdmissionsInformation: "Admissions Information",
        AdmissionsProgram: "Admissions Program",
        AdmissionsProgramOfferingItem: "Program Route",
        AdmissionsRecord: "Admissions Record",
        AdmissionsStage: "Admissions Stage",
        AdmissionsStatus: "Admissions Status",
        AdmissionsType: "Admissions Type",
        AdvancedSearch: "Advanced Search",
        AdvancedSearchActivate: "Advanced Search Activate",
        AfterTerms: "Final Terms & Conditions",
        AfterTermsDeclaration : "Declaration",
        AlgebraAndCoordGeometry: "Algebra/Coord. Geometry",
        AlienIDNumber: "Alien ID Number",
        All: "All",
        AlreadyCreatedAccountLoadInformation: "If you\u0027ve already created an account with us, please enter a user name and password and we\u0027ll try to load any previously acquired information.",
        AlternateEFC: "Alternate EFC",
        AlternativeAwards: "Alternative Awards",
        AlternativeEFC: "Alternative EFC",
        Amount: "Amount",
        AddPrivacyProfile: "Add Privacy Profile",
        AddPrivacyProfilePopupMessage: "Select a privacy profile from the list below to customize how your data is shared and protected. Your chosen profile will determine the level of visibility and access to your personal information.",
        AddBtnDisableToolTip: "Either all privacy profiles are added or none are currently available.",
        SecretQuestion: "Secret Question",
        SecretAnswer: "Secret Answer",
        AcceptAuthorizedPersonAccessMsg: "Are you sure you want to grant access to this person?",
        RevokeAuthorizedPersonAccessMsg: "Are you sure you want to revoke access for this person?",
        DeleteAuthorizedPersonMsg: "Are you sure you want to remove this authorized person?",
        DeleteSelectedProfileMsg: "Are you sure you want to delete the selected Student Data Privacy Profile?",
        Revoke: "Revoke",
        AddAuthorizedPerson: "Add Authorized Persons",
        AuthorizedPersonDetails: "Authorized Person Details",
        AccessGranted: "Access Granted",
        AccessRevoked: "Access Revoked",
        AccessPending: "Access Pending",
        AuthorizedPersons: "Authorized Persons",
        AuthorizedPeople: "Authorized People",
        Consent: "Consent",
        AcceptedOn: "Accepted on",
        RevokedOn: "Revoked on",
        DomicilePaymentSelectionHeading: "Please select your preferred payment method",
        AmountAlreadyPaid: "The amount already paid",
        AnalyticalWriting: "Analytical Writing",
        AntiSpamAnswerMismatch: "Verification Question does not match expected answer.",
        AntiSpamVerification: "Anti-Spam Verification",
        ApplicantEmailAddress: 'Applicant Email Address',
        ApplicantCorrespondenceAddress: 'Applicant Correspondence Address',
        ApplicantPermanentAddress: 'Applicant Permanent Address',
        ApplicationAutoSaved: "Application Auto-Saved...",
        ApplicationFeeNotRequired0: "A small application fee is requested, but payment may be delayed and is not required to submit an application.  The fees are {0}",
        ApplicationFeeRequired0: "A small application fee is required to apply.  The fees are {0}",
        ApasWarningMessage1: "For Alberta System applicants only.",
        ApasWarningMessage2: "Please remember to use APAS application first.Please click the following link to be redirected to APAS<a href = \"https://applyalberta.ca\">Apply Alberta</a>",
        ApasWarningMessage3:  "Finalizing application here without APAS will not finish your application.You must initalize your application at APAS then you will be redirected here. ",
        ApplicationGoal: "Application Goal",
        ApplicationInformation: "Application Information",
        ApplicationAttendedCourses: 'Have you previously attended one of our courses?',
        Apply: "Apply",
        ApplyCouponCode: "Apply Discount Code",
        Approve: "Approve",
        ApprovalPending: "Approval Pending",
        Archive: "Archive",
        Archived: "Archived",
        ArchivedMessages: "Archived Messages",
        Area: "Area",
        ArtsAndLiterature: "Arts/Literature",
        Assessment: "Assessment",
        Associations: "Associations",
        Attendance_Abb: "ATT",
        AttendanceReason: "Attendance Reason",
        AttendanceRecorded: "Attendance Recorded",
        AttendanceType: "Attendance Type",
        Attended: "Attended",
        AuditRequiredTotalPercent: "100",
        AvailableCourses: "Available Courses",
        AvailableDate: "Available Date",
        AvailableDates: "Available Dates",
        AvailableSeats: "Available Seats",
        AverageStartDate: "Average Start Date",
        AverageEndDate: "Average End Date",
        AWA: "AWA",
        AwaitingQualification: "If you are awaiting confirmation of grade, please tick 'Awaiting Result'. If ticked, the word 'Pending' is inserted into the Qualification Grade field",
        AwaitingResult: "Awaiting Result",
        AwardIsLocked: "Award is locked",
        AwardType : 'Award Type',
        BackToList: "Back to List",
        BackToTop: "Back to Top",
        Balance: "Balance",
        BalanceAmount:"Balance Amount",
        BalanceForward: "Balance Forward",
        BalanceNetOfPendingAid: "Balance Net of Pending Aid",
        BeforeTerms: "Initial Terms & Conditions",
        PrivacyNotice: 'Privacy Notice',
        BeginDate: "Begin Date",
        Beneficiary: "Beneficiary",
        BeneficiaryName: "Beneficiary Name",
        BeneficiariesList: "Beneficiaries List",
        BillableTransactions: "Billable Transactions",
        BillingAction: "Billing Action",
        BillingAddress: "Billing Address",
        BillingPeriod: "Billing Period",
        BillingStateCurrentBalance: "Payable Now",
        BillingStateFuturePeriod: "Future Period",
        BillingStateOverdue: "Overdue",
        BillingSummary: "Billing Summary",
        BirthCountry: "Country of Birth",
        BirthDate: "Birth Date",
        BldgRoom: 'Bldg. – Room',
        BrowserDoesNotSupportHTML5Uploads: "This browser doesn\u0027t support HTML5 file uploads!",
        BudgetComponent: "Budget Component",
        RecalculateTotalAmount: "Recalculate",
        Campus: "Campus",
        Cancel: "Cancel",
        Cancel0: "Cancel {0}",
        CancelRegistration: "Cancel Registration",
        CardNumber: "Card Number",
        ChangeRole: "Change Role",
        Charged: "Charged",
        CheckNewTermsVersion: "New version of paragraph. Please click to see changes",
        ChooseUpToThreeOneRequired: "Choose up to 3, at least one selection is required.",
        Citizenship: "Citizenship",
        City: "City",
        Clear: "Clear",
        ClearAndReUpload: "Clear \u0026 Re-Upload",
        ClickHereToProceed: "Click here to proceed",
        ClickToShowRecorded: "Click to show recorded.",
        ClockHours: "Clock Hours",
        Close: "Close",
        College: "College",
        CollegeEndDate: "College End Date",
        CollegeInformation: "College Information",
        Colleges: "Colleges",
        CollegeSearch: "College Search",
        CollegeStartDate: "College Start Date",
        Comment: "Comment",
        Communications: "Communications",
        Completed: "Completed",
        CompletionDate: "Completion Date",
        Composite: "Composite",
        Condition: "Condition",
        Confirm: "Confirm",
        ConfirmEmail: "Confirm Email",
        ConfirmEmailAddress: "Confirm Email Address",
        ConfirmPassword: "Confirm Password",
        CongratulationsText: '<p>Congratulations, we are delighted to offer you a place to study at Manchester Metropolitan University. Please confirm your decision to accept or decline this offer by selecting the appropriate option below.</p><p>Before you accept, please make sure you have read the full details of your offer. An offer pack, containing your formal offer letter and additional important information, will be sent to you by email within three days of the offer decision. If you have not received your offer pack within three days, please <a href="mailto:courses@mmu.ac.uk">contact us.</a></p>',
        ConservatoireSpecialisms: "Conservatoire Specialisms",
        Contact: "Contact",
        ContactDetails: "Contact Details",
        ContactInformation: "Contact Information",
        CoRequisiteDropConflict: "CoRequisite Drop Conflict",
        CoRequisiteSelection: "Co-Requisite Selection",
        CorrespondenceAddress: "Correspondence Address",
        Cost: "Cost",
        CostOfAttendance: "Cost of Attendance",
        CouldNotRetrieveErrorMessage: "Could not retrieve error message",
        CountryName: "Country Name",
        County: 'County/State',
        CouponWaiverCode: "Coupon/Waiver Code",
        Course: "Course",
        CourseTitleHelp: 'Please indicate the name of your course as shown on your certificate or transcripts.',
        CourseAlreadyCompleted: "This course has already been completed",
        CourseAlreadyEnrolled: "This course is already registered",
        CourseAlreadyReserved: "This course is already reserved",
        CourseAlreadyWaitlisted: "This course is on the wait list",
        CourseCoRequisitesNotCompleted: "This course has co-requisites that can not be completed.",
        CourseID: "Course ID",
        CourseIsFull: "Course is Full.",
		ClassIsFull: "Class is full.",
		ClassFullandWaitlistFull:"The selected class has no available seats and the waitlist is full.",
		ClassFullandWaitlistFullHead:"Class And Waitlist Is Full.",
        ClassIsFullAddToWaitlist: "The selected class has no available seats but has an open waitlist. Add student to waitlist?",
        ClassFullandNoWaitList: "The selected class has no available seats.",
        CourseEndDate: "Course End Date",
        CourseIsFullUseWaitlistFalse: "This course is full and cannot be waitlisted.",
        CourseKeywordSearch: "Course Keyword Search",
        CourseMaximumUnitConflict: "This course has a maximum units conflict with either number of credits or hours or courses.",
        CourseName: "Course Name",
        CourseNoRoster: "No Roster for this course.",
        CourseNumber: "Course Number",
        CoursePeriod: "Course Period",
        CoursePreRequisitesNotCompleted: "This course has pre-requisites that have not been completed",
        CourseRequiresFacultyApproval: "This course requires faculty approval before it can be reserved.",
        Courses: "Courses",
        CourseScheduleConflict: "There is a scheduling conflict for this course.",
        CourseScheduleConflict0: "There is a scheduling conflict between this course and {0}.",
        CourseSelectionMaxSubmissionsReachedMessage: "You have reached the maximum number of course selection submissions allowed.",
        CourseSelectionSubmissionsMessage0: "You have a maximum of {0} course selection submission(s) remaining.",
        CourseSelectionConfirmPlaceMessage: "You must submit your course selections to confirm your place.",
        CoursesRegistered: "Courses Registered",
        CoursesReserved: "Courses Reserved",
        CourseStartDate: "Course Start Date",
        CourseStatus: "Course Status",
        CoursesThatSatisfy0: "Courses That Satisfy {0}",
        CoursesWaitlisted: "Courses Waitlisted",
        CourseTerm: "Course Term",
        CourseTitle: "Course Title",
        CourseType: "Course Type",
        CourseWillBeDropped: "Course Will Be Dropped",
        CourseWillBeWithdrawn: "Course Will Be Withdrawn",
        CreateAnAccountInquiryAlreadyHaveOne0_Question: "Entering a password and creating an account will allow your information to be populated automatically in any future visits to our site. Already have an account? {0}",
        Credit: "Credit",
        CreditAmount: "Credit Amount",
        CreditHours: "Credit Hours",
        CreditHours_Abb: "Cr. Hrs.",
        Credits: "Credits",
        CreditType: "Credit Type",
        CreditTypes: "Credit Types",
        CriminalConviction: "Criminal Conviction",
        Cummulative_Abb: "Cum",
        CummulativeGPA: "Cumulative Average",
        FinalGrade: "Final Grade",
        Currency: "Currency",
        CurrentDateIsNotMeetingDate: "The currently selected date is not a scheduled meeting date.",
        CurrentDegree: "Current Degree",
        CurrentEmployer: "Current Employer",
        CurrentEmployerTooltip: 'If you are still working for this employer, please tick this box',
        CurrentWaitlist0: "Current waitlist: {0}",
        CVV: "CVV",
        ConferralDate: 'Conferral Date',
        Credential: 'Credential',
        ProgramName: 'Program Name',
		StudentNumber: 'Student Number',
        DALegend_Completed: "\u003cb\u003eC\u003c/b\u003e - Completed",
        DALegend_ExtraCourse: "\u003cb\u003eE\u003c/b\u003e - Extra Course",
        DALegend_InProgress: "\u003cb\u003eIP\u003c/b\u003e - In Progress",
        DALegend_ManualMapCompleted: "\u003cb\u003eMC\u003c/b\u003e - Manual Map Completed",
        DALegend_ManualMapRemaining: "\u003cb\u003eMR\u003c/b\u003e - Manual Map Remaining",
        DALegend_Remaining: "\u003cb\u003eR\u003c/b\u003e - Remaining",
        DALegend_TransferCompleted: "\u003cb\u003eTC\u003c/b\u003e - Transfer Completed",
        DALegend_TransferRemaining: "\u003cb\u003eTR\u003c/b\u003e - Transfer Remaining",
        DALegend_Waived: "\u003cb\u003eWV\u003c/b\u003e - Waived",
        DALegend_Compensated: "\u003cb\u003eCM\u003c/b\u003e - Compensated",
        DALegend_Condoned: "\u003cb\u003eCN\u003c/b\u003e - Condoned",
        DALegend_Reserved: "\u003cb\u003eRV\u003c/b\u003e - Reserved",
        DALegend_Waitlisted: "\u003cb\u003eW\u003c/b\u003e - Wait-listed",
        DataPrivacyProfiles: "Data Privacy Profiles",
        Date: "Date",
        DateCompleted : "Date Completed",
        DatesAttendedTo: 'Date attended to',
        DatesAttendedFrom: 'Date attended from',        
        DatesAttended: "Dates Attended",
        DateFormatExample: "mm/dd/yyyy",
        DateFrom: "Date From",
        DateOfBirth: "Date of Birth",
        DateOfEntryToUK: "Date Of Entry To UK",
        DateOfServiceFrom: "Date of Service From",
        DateOfServiceTo: "Date of Service To",
        DateRange: "Date Range",
        Dates: "Dates",
        DatesAttended: "Dates Attended",
        DatesForSelectedSession: "Dates for Selected Session",
        DateOfAssessment: "Date of Assessment",
        DatesOfService: "Dates of Service",
        DateTo: "Date To",
        DaysAndTimes: "Days \u0026 Times",
        Debit: "Debit",
        DebitAmount: "Debit Amount",
        Decline: "Decline",
        Degree: "Degree",
        DegreeAuditList: "Degree Audit List",
        DegreeShopping: "Degree Shopping",
        Delete: "Delete",
        DeleteDocument0_Question: "Are you sure you wish to delete document: {0}?",
        DeleteRecord_Question: "Are you sure you want to delete this record?",
        DeliveryMethod: "Delivery Method",
        DeliveryMode: 'Delivery Mode',
        Location: "Location",
        Demographic: "Demographic",
        DemographicDescription: 'RCA is required to collect certain information from applicants for internal and external monitoring purposes. Full details are in our Privacy Statement <a target="_blank" href="https://www.rca.ac.uk/contact-us/about-this-website/privacy-cookies/">here</a>',
        DemographicInformation: "Demographic Information",
        Denied: "Denied",
        Deny: "Deny",
        Deposit: "Deposit",
        DepositTransactionSum: "Refundable Deposit",
        Description: "Description",
        DisabledStudentAllowance: "Disabled Student Allowance",
        Disability: "Disability",
        DisabilityCondition1: 'Do you have a disability, specific learning difficulty or health condition? ',
        DisabilityCondition2: 'Disability, Specific Learning Difficulty or Health Condition',
        DisabilityTextInfo: 'We aim to create an environment that enables all students to participate fully in university life. To help us make any reasonable adjustments that may be necessary, please tell us about any disability, specific learning difficulty or health condition you may have. If this does not apply to you, please select ‘No known disability’. This information will not be used in the selection process.',
        DisabilityGuidanceText: '<i>This is the information you have disclosed to the University about a disability, health condition, mental health difficulty or Specific Learning Difficulty.  This information comes to us either at the point of your applying for a course or when you create a disability support request with the Disability Service. You can <a href="https://studenthub.mmu.ac.uk/mydisabilitysupport/" target="_blank" class="mmu_disabilities_guidance_text">apply for support, or update your disability support request and disclosure</a> through the Digital Student Hub if your support needs change.</i>',
        DisbursementNumber: "Disbursement Number",
        DocumentDate: "Document Date",
        DocumentImage: "Document Image",
        DocumentName: "Document Name",
        Documents: "Documents",
        DocumentStatus: "Document Status",
        DocumentChecklistItemText: 'Download {0} template.',
        DocumentType: "Document Type",
        DoNotApprove: "Do not approve",
        DoNotContact: "Do Not Contact",
        DoNotContact_Question: "Do Not Contact?",
        DoNotContactReason: "Do Not Contact Reason",
        DoNotContact_Tooltip: "Select if you want to limit contact from the university, except the e-mails sent for the proper performance of the Student's Portal.",
        DoNotShareDirectoryClientText: 'Please don’t share my information on the directory',
        Download: "Download",
        DownloadCalendar: "Download Calendar",
        DownloadYourReceipt: "Download your Receipt",
        DoYouWantToCancelRegistration_Question: "Do you wish to cancel your registration?",
        DoYouHaveDisability: 'Do you have a learning difference or disability?',
        DropAll: "Drop All",
        DropAlert: "Drop Alert",
        DropCourse: "Drop Course",
        DropFailed: "Drop Failed",
        DropFailedTryAgain: "Drop Failed, Try Again",
        Dropout: "Dropout",
        DroporWithdrawfromCourses: 'Drop or Withdraw from Courses',
        DualNationality: "Dual Nationality",
        DueDate: "Due Date",
        DueAmount: "Due Amount",
        DuplicateElectronicAddressError: "{0} has more than one Primary electronic address with the same type.",
        DuplicatePhoneNumberError: "{0} has more than one Primary phone number with the same type.",
        DuplicateMailingAddressError: "{0} has more than one Primary address.",
        EarliestStart: "Earliest Start",
        Earned: "Earned",
        Edit: "Edit",
        EditFile: "Edit File",
        Editing: "Editing...",
        EditMyProfile: "Edit My Profile",
        EducationAdviser_message: 'An Education Adviser provides application advice and services to prospective international students on behalf of the University.',
        EducationAdviser: 'Are you an Education Adviser?',
        EducationAdviserFieldHelp: 'Education Adviser Field Help',
        EducationAdviserGuidanceI: 'Please provide your company’s Education Adviser ID (if known) and input your email address in the Email Address field. This will be the primary email address we use for correspondence.',
        EducationAdviserGuidanceII: 'Please provide the applicant’s own details in the Primary Phone Number, Applicant Email Address, Correspondence Address and Permanent Address fields.',
        EducationAdviserID_Message: 'Enter your Education Adviser Code if you have been assigned one, or leave blank if not.',
        EducationAdviserID: 'Education Adviser ID',
        EducationalGoal: "Educational Goal",
        EducationReceived: "Education Received",
        EffectiveBegin: "Effective Begin",
        EffectiveDate: "Effective Date",
        EffectiveEnd: "Effective End",
        EffectiveFrom: "Effective From",
        EffectiveTill: "Effective Till",
        ElectronicAddresses: "Electronic Addresses",
        Email: "Email",
        EmailAddress: "Email Address",
        EmailDoesNotMatch: "Email and Confirm Email must match",
        EmailFormat: 'Value must be in email format.',
        EmailUsernameWithNextApplicationSteps: "An email has been sent to you with your username and a link to the next step, filling out an Application.",
        EmergencyContacts: "Emergency Contacts",
        Employment: "Employment",
        EmployerTextDependency: 'We need to create your account before you enter information on this section, please fill "Privacy Notice", "Personal" and "Contact" sections.',
        EmployerTextTwo: 'For each employer, click "Add Employment" to add them to the list. If you wish to update or delete an employer, click on the relevant option for the employer listed.',
        EmployerTextOne: 'Please enter details of all recent and relevant work experience below (including training, paid / unpaid, and full-time / part-time work).',
        EmploymentDetails: "Employment Details",
        EmploymentEndDate: "Employment End Date",
        EmploymentStartDate: "Employment Start Date",
        EmploymentStatus: "Employment Status",
        EmployerTooltip: 'Please enter the name of the company/organisation.',
        EndDate: "End Date",
        EndDateGreaterThanStartDate: "Please select an End Date greater than the Start Date.",
        English: "English",
        EnglishIsPrimaryLanguage: 'English is first language',
        EnglishPrimaryLanguage: 'Is English your first language?',
        EnglishSubScores: "English Sub-Scores",
        Enrolled: "# Enrolled",
        EnrollmentLevel: "Enrollment Level",
        EnrollmentLoad: "Enrollment Load",
        EnrollmentMode: "Enrolment Mode",
        Enrollments: "Enrollments",
        EnrollmentStatus: "Enrollment Status",
        Enrolments: 'Enrolments',
        EnterDateRange: "Please enter a date range.",
        EnterPasswordToContinueApplication: "Please enter your password to continue your application.",
        EnterValidEmail: 'Please enter the same email as above',
        EntryPoint: "Entry Point",
        EprospectusApoiQStringPar : 'apoi',
        Erned_Abb: "ERN",
        Error: "Error",
        ErrorAccessingPage: "There was an error accessing this page",
        ErrorCalculatingPreviewCharge: "An error occurred calculating estimated price. Please contact the administrator to correct this issue.",
        ErrorCancelingRegistration: "An error occurred canceling registration.",
        ErrorCreatingAccountRequestSubmitted: "There was an error creating your user account, however the request was submitted successfully.",
        ErrorCreatingUser: "Error Creating User",
        ErrorFetchingPaymentInformation: "There was an error fetching payment information",
        ErrorInRegistration: "There was an error while trying to register. Please contact your administrator",
        ErrorOccuredWithWebsite: "We apologize, but an error has ocurred with the website.",
        ErrorProcessingPayment: "There was an error processing this payment",
        ErrorRetrievingSectionData: "There was an error retrieving data for this section",
        Errors: "Errors",
        ErrorMessageOnSave: 'An error has occurred while saving your information. Please refresh the page to try again.',
        ErrorMessageOnSaveForInternet: 'An error has occurred while saving your information. Please check your internet connection and refresh the page to try again.',
        ErrorMessageOnFetch: 'An error has occurred while fetching your information. Please refresh the page to try again.',
        ErrorMessageOnFetchForInternet: 'An error has occurred while fetching your information. Please check your internet connection and refresh the page to try again.',
        ErrorMessageNotLoggedIn: 'An error has occurred while creating your record. Please enter your details again.',
        Essay: "Essay",
        EstimatedAmountToPay: "Estimated Amount to Pay:",
        EstimatedCostOfAttendance: "Estimated Cost of Attendance",
        EthnicOrigin: "Ethnic Origin",
        Ethnicity: 'Ethnicity (Permanent UK Residents Only)',
        ETSID: "ETSID",
        ExamBoard: "ExamBoard",
        Excused: "Excused",
        ExistingSponsors: "Existing Sponsors:",
        ExpectedEnrollmentLoad: "Expected Enrollment Load",
        ExpectedEntrancePeriod: "Expected Entrance Period",
        ExpectedEnrollmentType: "Expected Attendance Pattern",
        ExpirationDate: "Expiration Date",
        ExpirationDateWithFormat: "Expiration Date (mm/yyyy)",
        Expired: "Expired",
        Extension: "Extension",
        Extension_Abb: "Ext.",
        EmergencyPrimaryContact: 'Only one contact can be set as the primary contact. To select a new primary contact, please disable the existing one first.',
        Faculty: "Faculty",
        Faculty360ForAttendance: "Click \"Faculty 360\" to access record attendance",
        FacultyApproval: "Faculty Approval",
        FacultyDetails: "Faculty Details",
        FallDue: "Fall due",
        FeatureNotImplemented: "This feature has not yet been implemented.",
        Fee0ForUGrad1ForGrad2ForDoctoral: "{0} for undergraduate applications, {1} for graduate applications, and {2} for doctoral applications.",
        Fees: "Fees",
        FeesAndPayment: "Fees and Payment",
        FieldIsInvalid: "Field is Invalid",
        File: "File",
        FileName: "File Name",
        Filter: "Filter",
        FinalGrade: "Final Grade",
        FinalGrade_Abb: "Final",
        FinancialAid: "Financial Aid",
        FinancialAidAwardAcceptingTooltip: "Final Award acceptance",
        FinancialAidAwardRejectingTooltip: "Final Award rejection",
        FinancialAidAwardCancelTooltip: "Cancel and close",
        FinancialAidAwardAcceptingTitle: "Award accepting",
        FinancialAidAwardAcceptingBody: "Are you sure that you want to accept the Award?",
        FinancialAidAwardRejectingTitle: "Award rejecting",
        FinancialAidAwardRejectingBody: "Are you sure that you want to reject the Award?",
        FinancialAidAwardAcceptingAllTitle: "All Awards accepting",
        FinancialAidAwardAcceptingAllBody: "Are you sure that you want to accept all Awards? Already accepted / rejected Awards will be skipped.",
        FinancialAidAwardRejectingAllTitle: "All Awards rejecting",
        FinancialAidAwardRejectingAllBody: "Are you sure that you want to reject all Awards? Already accepted / rejected Awards will be skipped.",
        FinancialAidPeriod: "Financial Aid Period",
        FinancialDataNotAvailable: "Financial Data Not Available",
        FirstName: "First Name",
        FirstGivenName:"First (Given) Name",
        FirstPage: "First Page",
        FirstInstallmentAmount: "First Installment Amount",
        FixedSurcharge: "Fixed Surcharge",
        FirstInstallmentPercentage: "First Installment Percentage",
        ForeignCitizenInformation: "Foreign Citizen Information",
        ForeignCitizenInformationText: 'Additional Citizenship Information',
        Forgiven: "Forgiven",
        Form: "Form",
        From: "From",
        FullName: 'Full Name',
        Frequency: "Frequency",
        GEDTest: "GED Test",
        GEDTestDate: "GED Test Date",
        GeneratedContactID: "Generated Contact ID",
        Gender: "Gender",
        GenderSameBirth: "Same Gender Identity as at Birth",
        GMATScores: "GMAT Scores",
        GMATTest: "GMAT Test",
        GMATTestDate: "GMAT Test Date",
        Goal: "Goal",
        GoalAndStatus: "Goal \u0026 Status",
        GoalStanding: "Goal Standing",
        GoToNext: "Go To Next",
        GoToPrevious: "Go To Previous",
        GoToNextBottom: "Go To Next Bottom",
        GoToPreviousBottom:"Go To Previous Bottom",
        GPA: "Average",
        GPAAttained: "Average Attained",
        GPAHours: "GPA Hours",
        GPAScale: "GPA Scale",
        Grade: "Grade",
        GradeCalculationTitle: "This is the score which is being used in the Grade Calculation",
        GradePoint: "Grade Point",
        GradePointScale: "Grade Point Scale",
        Graduated: "Graduated",
        GraduatedDate: "Graduated Date",
        GraduationDate: "Graduation Date",
        GREScores: "GRE Scores",
        GRETest: "GRE Test",
        GRETestDate: "GRE Test Date",
        Gross: "Gross",
        GrossAmount: "Gross Amount",
        Group: "Group",
        GroupName: "Group Name",
        GradeStatus: "Grade Status",
        RuleStatus: "Rule Status",
        GradeType: "Grade Type",
        TestType: "Test Type",
        SubGroup: "Sub Group",
        TestField: "Field",
        HeardAboutInstitute: 'How did you hear about us?',
        HeardAboutInstituteFrom: "How did you hear about this institute?",
        HighestQualification: "Highest Qualification",
        HighSchool: "High School",
        HighSchoolEndDate:"High School End Date",
        HighSchoolInformation: "High School Information",
        HighSchoolInfo0ne: 'Please provide details of the schools, colleges and universities where you have previously studied. If applying for postgraduate study, please select or input the name of the institution where you obtained your first degree or most relevant professional qualification.',
	    HighSchoolInfoTwo: 'Please add details of a previous institution by using the search box below. If the institution is not found, please complete the full name of the institution and provide the city, country and dates attended.',
        HighSchools: "High Schools",
        HighSchoolSearch: "High School Search",
        HighSchoolStartDate: "High School Start Date",
        HighSchoolText: 'Previous Education Institutions',
        Hispanic: "Hispanic",
        HistoricalData: "Historical Data",
        Holds: "Holds",
        Hours: "Hours",
        Hours_Abb: "HRS",
        ID: "ID",
        IfDifferentFromAbove: "(if different from above)",
        IsParentGraduate: "Have either of your parents/guardians attended a university or college?",
        IfOther: "If Other",
        ImageExtensionErrorMessage: "Unsupported file type. Use one of types: .jpg, .jpeg, .png, .bmp.",
        ImageInformationMessage: "Please select jpg, jpeg, bmp or png file with size below 2MB. Preferred dimension: 200x200px.",
        ImageSizeErrorMessage: "This file is too big. Please select file with size below 2MB.",
        ImmigrationCategory: 'Under what immigration category will you enter the UK?',
        IndigenousStatus: 'Indigenous Status', 
        Information: "Information",
        Installments: "Installments",
        InitialEnrollmentStatus: "Initial Enrollment Status",
        InProgress: "In-Progress",
        Inquiry_ExpectedStart_Question: "When are you expecting to start your new academic career?",
        Inquiry_HowTakeCourses_Question: "How would you like to take your courses?",
        Inquiry_PreferredDegreeLevel_Question: "What degree level do you plan to pursue?",
        Inquiry_PreferredMethodOfContact_Question: "What is your preferred method of contact?",
        Inquiry_WhatMajor_Question: "What is your desired major?",
        Inquiry_WhereToStudy_Question: "Where would you like to study?",
        InstituteCoursesPreviouslyTaken: "What courses from this institute have you taken before?",
        InstituteRelationship: "Do you, or a member of your family, have an existing relationship with this institute or any of its employees?",
        InstituteRelationshipDescription: "Details of existing relationship",
        InstituteRelationshipName: "Name of person who has existing relationship",
        Instructor_WithPlural: "Instructor(s)",
        Instructors: "Instructors",
        InternationalInformation: 'International Information',
        InterviewInPerson: "in person",
        InterviewPreferences: "If invited for an interview, I would prefer to be interviewed",
        InterviewViaPhone: "via phone",
        InterviewViaSkype: "via Skype",
        InvoiceAmount: "Invoice Amount",
        Invoiced: "Invoiced",
        InvoicedAmount: "Invoiced Amount",
        InvoiceDate: "Invoice Date",
        InvoiceDownloadFailedHeader: "Invoice Download Failed",
        InvoiceDownloadFailedMsg:"We're sorry, but we're unable to locate your invoice. Please contact your administrator.",
        InvoiceFor: "Invoice For",
        InvoiceNumber: "Invoice Number",
        InvoiceSummary: "Invoice Summary",
        Invoices: "Invoices",
        IndigenousPersonDeclarationID: "Indigenous Person Declaration",
        Language: "Language",
        Languages: "Languages",
        LanguageAssessment: 'English Language Assessment',
        LanguageAssessmentText1: 'The College requires students to have a certain level of English language proficiency. Please add details of the language assessment you have completed if English is not your first language. Select “Due to complete” in the dropdown if you have not completed an assessment yet.',
        LanguageAssessmentText2: "Full details about English language requirements can be found <a href='https://www.rca.ac.uk/studying-at-the-rca/apply/entrance-requirements/english-language-requirements/' target='_blank'>here</a>",
        LanguageAssessmentName: 'Language Assessment name',
        LastName: "Last Name",
        LastPage: "Last Page",
        LastFamilyName: 'Last (Family) Name',
        LanguageSection_Note: 'All applicants must provide evidence that they meet the minimum English Language requirements for their chosen programme.',
        LanguageSection_ScoreGuidanceText: 'If applicable to your qualification, please provide the scores below',
        LanguageSection_ScoreListeningLabel: 'Listening score',
        LanguageSection_ScoreReadingLabel: 'Reading score',
        LanguageSection_ScoreSpeakingLabel: 'Speaking score',
        LanguageSection_ScoreWritingLabel: 'Writing score',
        LastUpdateDate: "Last Update Date",
        LanguageSectionLabel: 'English Language Skills',
        LanguageQualificationDateLabel: 'Date qualification obtained',
        LanguageQualificationDateTooltipLabel: 'If you have completed this qualification please enter the date on which it was obtained',
        LanguageQualificationLabel: 'How do you plan to meet the English language requirement for your programme?',
        ProficiencyAwaytingTooltip: "If you are awaiting confirmation of your overall grade, please tick 'Awaiting Result'",
        Late: "Late",
        LatestEnrollment: "Latest Enrollment",
        Legend: "Legend",
        LengthOfCompletion: "Length of Completion",
        Level: "Level",
        LinkToContinueApplication: "Continue to Full Application",
        LinkToStudent360: "Continue to Student 360",
        ListeningScore: 'Listening Score',
        LoadCourses: "Load Courses",
        LoadCoursesBy: "Load courses by",
        LOADING: "LOADING...",
        LoadingPleaseWait: "Loading, please wait...",
        LoggedInAs: "Logged in as:",
        Login: "Login",
        LoginDialogTitle: 'Log in',
        LoginHere: "Login here",
        Logout: "Logout",
        LogoutDialogTitle: 'Log out',
        LostUsername: "Lost Username?",
        LostPassword: "Lost Password?",
        MA_ALL_BuildingName: "Building Name",
        MA_ALL_CareOf: "Care Of",
        MA_ALL_City: "City",
        MA_ALL_CountryID: "Country",
        MA_ALL_County: "County",
        MA_ALL_Floor: "Floor",
        MA_ALL_GoverningDistrictID: "Governing District",
        MA_ALL_GoverningDistrictName: "Governing District",
        MA_ALL_Miscellaneous1: "Miscellaneous 1",
        MA_ALL_Miscellaneous2: "Miscellaneous 2",
        MA_ALL_Miscellaneous3: "Miscellaneous 3",
        MA_ALL_Municipality: "Municipality",
        MA_ALL_PostalCode: "Postal Code",
        MA_ALL_PostOfficeBoxNumber: "Post Office Box Number",
        MA_ALL_StreetDirection: "Street Direction",
        MA_ALL_StreetName: "Street Name",
        MA_ALL_StreetNumber: "Street Number",
        MA_ALL_StreetSuffixID: "Street Suffix",
        MA_ALL_StreetSuffixName: "Street Suffix",
        MA_ALL_UnitNumber: "Unit Number",
        MA_C1_City: "City",
        MA_C1_CountryID: "Country",
        MA_C1_GoverningDistrictID: "Province",
        MA_C1_GoverningDistrictName: "Province",
        MA_C1_PostalCode: "Postal Code",
        MA_C1_StreetName: "Street Name",
        MA_C1_StreetNumber: "Street Number",
        MA_C1_StreetSuffixID: "Street Suffix",
        MA_C1_StreetSuffixName: "Street Suffix",
        MA_C1_UnitNumber: "Unit Number",
        MA_C10_CountryID: "Country",
        MA_C10_GoverningDistrictID: "Governing District",
        MA_C10_GoverningDistrictName: "Governing District",
        MA_C10_PostOfficeBoxNumber: "Post Office Box Number",
        MA_C11_BuildingName: "Building Name",
        MA_C11_City: "City",
        MA_C11_CountryID: "Country",
        MA_C11_County: "County",
        MA_C11_Municipality: "Municipality",
        MA_C11_PostalCode: "Postal Code",
        MA_C11_StreetName: "Street Name",
        MA_C11_StreetSuffixID: "Street Suffix",
        MA_C11_StreetSuffixName: "Street Suffix",
        MA_C115_City: "City",
        MA_C115_CountryID: "Country",
        MA_C115_PostalCode: "Postal Code",
        MA_C115_PostOfficeBoxNumber: "Post Office Box Number",
        MA_C115_StreetName: "Street Name",
        MA_C115_StreetNumber: "Street Number",
        MA_C115_StreetSuffixID: "Street Suffix",
        MA_C115_StreetSuffixName: "Street Suffix",
        MA_C12_AddressLine1: "Address Line 1",
        MA_C12_AddressLine2: "Address Line 2",
        MA_C12_AddressLine3: "Address Line 3",
        AddressSearch: 'Address Search',
        MA_C12_City: "City",
        MA_C12_CountryID: "Country",
        MA_C12_GoverningDistrictID: "State",
        MA_C12_GoverningDistrictName: "State",
        MA_C12_Municipality: "Municipality",
        MA_C12_PostalCode: "Postal Code",
        MA_C12_PostOfficeBoxNumber: "Post Office Box Number",
        MA_C12_StreetDirection: "Street Direction",
        MA_C12_StreetName: "Street Name",
        MA_C12_StreetNumber: "Street Number",
        MA_C12_StreetSuffixID: "Street Suffix",
        MA_C12_StreetSuffixName: "Street Suffix",
        MA_C12_UnitNumber: "Unit Number",
        MA_C2_City: "City",
        MA_C2_CountryID: "Country",
        MA_C2_Municipality: "Municipality",
        MA_C2_PostalCode: "Postal Code",
        MA_C2_StreetName: "Street Name",
        MA_C2_UnitNumber: "Unit Number",
        MA_C4_BuildingName: "Building Name",
        MA_C4_City: "City",
        MA_C4_CountryID: "Country",
        MA_C4_County: "County",
        MA_C4_Floor: "Floor",
        MA_C4_GoverningDistrictID: "Governing District",
        MA_C4_GoverningDistrictName: "Governing District",
        MA_C4_Municipality: "Municipality",
        MA_C4_PostalCode: "Postal Code",
        MA_C4_StreetName: "Street Name",
        MA_C4_StreetNumber: "Street Number",
        MA_C4_UnitNumber: "Unit Number",
        MA_C9_City: "City",
        MA_C9_CountryID: "Country",
        MA_C9_Municipality: "Municipality",
        MA_C9_PostalCode: "Postal Code",
        MA_C9_PostOfficeBoxNumber: "Post Office Box Number",
        MA_C9_StreetName: "Street Name",
        MA_C9_StreetNumber: "Street Number",
        MA_C9_UnitNumber: "Unit Number",
        MA_BuildingName: 'Building Name / No',
        MA_Town: 'Town / City',
        MA_Municipality :'Locality / area',
        MA_PostalCode :'Postcode',
        MailingAddress: "Mailing Address",
        Major: "Major",
        MajorChoiceOne: "Major Choice #1",
        MajorChoiceThree: "Major Choice #3",
        MajorChoiceTwo: "Major Choice #2",
        MakePayment: "Make Payment",
        MassActions: "Mass Actions",
        MassHours: "Mass Hours",
        MassStatus: "Mass Status",
        Math: "Math",
        MathSubScores: "Math Sub-Scores",
        MatriculationStatus: "Matriculation Status",
        Max: "Max",
        MaxCreditsForBlock: "Maximum Credits for Block",
        MaxCreditsForBlockConflict: "Cannot reserve this course because the number of credits would exceed the total allowed for this block.",
        MaxDocumentsLimitAchieved0: "Maximum {0} documents limit for selected Document Type was achieved.",
        MaxTotalAmount: "Maximum Total Amount",
        DocumentTypesNotFound0: "No Document Type was setup for this Area.",
        MaximumBalanceAmount: "Maximum Balance Amount",
        Maximum1ItemAmount: "Maximum Amount for 1 item",
        MaximumUnitsConflict: "Maximum Units Conflict",
        MaximumUnitsConflictAcademicRecord: "Maximum Units Conflict with your academic record.",
        MaximumUnitsConflictEnrollmentLevel: "Maximum Units Conflict with you enrollment level.",
        MaximumUnitsConflictProgram: "Maximum Units Conflict with your program.",        
        MemberType: "Member Type",
        Message: "Message",
        MessageSent_Exclamation: "Message Sent!",
        MetBy: "Met By",
        MiddleName: "Middle Name",
        MidTermGrade: "Mid-Term Grade",
        MidTermGrade_Abb: "Mid",
        Military: "Military",
        MilitaryService: "Military Service",
        MilitaryStatus: "Military Status",
        Min0Required: "Min {0}  Required",
        Minimum1ItemAmount: "Minimum Amount for 1 item",
        MinimumBalanceAmount: "Minimum Balance Amount",
        MinCreditsForBlock: "Minimum Credits for Block",
        MinCreditsForBlockConflict: "Cannot proceed, there aren't enough credits selected from one of your registration blocks.",
        MinGPARequired: "Min Average Required",
        Minimum0Required: "Minimum {0} Required",
        MinimumGPARequired: "Minimum Average Required",
        MinTotalAmount: "Minimum Total Amount",
        MinUnitConflict: "Minimum Units Conflict",
        MinimumUnitsConflictAcademicRecord: "There is a minimum units conflict with your academic record.",
        MinimumUnitsConflictProgram: "There is a minimum units conflict with your program.",
        MinimumUnitsConflictEnrollmentLevel: "There is a minimum units conflict with your enrollment level.",
        MinUnitConflictMessage: "There is a minimum units conflict with either number of credits or hours or courses.",
        MilestoneDeadline: "Milestone Deadline for Waitlisted Courses",
        MilestoneDeadlinePassedWaitlistMessage: "Milestone date has passed. Course cannot be waitlisted.",
        MilestoneInFutureWaitlistMessage: "Milestone date is in future. Course cannot be waitlisted.",
        Mixed: "Mixed",
        MobilePhoneNumber: "Mobile Phone Number",
        Mode: "Mode",
        ModeOfAttendance: 'Mode of Attendance',
        Modify: "Modify",
        MustBeAFutureDate: 'The date must be later than the current date.',
        MustBeEnrolledRequiredCoRequisites: "Must be enrolled in all required CoRequisites.",
        MustBeProperQualificationObtainedDate: "Date Qualification Obtained must be between 1900 and current date",
        MyAwards: "My Awards",
        MyCourses: "My Courses",
        MyGrades: "My Grades",
        MyOfficialTranscript: "My Official Transcript",
        MySchedule: "My Schedule",
        MySponsors: "My Sponsors",
        MyStudents: "My Students",
        MyUnofficalTranscript: "My Unofficial Transcript",
        Name: "Name",
        Need0Of1ToCompleteRequirement: "You need {0} additional {1} to complete this requirement.  View applicable courses.",
        Net: "Net",
        NetAmount: "Net Amount",
        New: "New",
        NewMessage: "New Message",
        Next_Abb: "Next",
        NextPage: "Next Page",
        No: "No",
        NoAccessibilityNeedInformationEntered: "No Accessibility Need Information Entered",
        NoAccessibilityNeedsAdded: "No Accessibility Needs Added",
        NoACTScoresAdded: "No ACT Scores Added",
        NoAddresses: "No Addresses",
        NoBillingSummary: "No Billing Summary",
        NoCollegeInformationEntered: "No College Information Entered",
        NoCollegesAdded: "No Colleges Added",
        NoCommunications: "No Communications",
        NoCourses: "No Courses",
        NoCoursesForPeriod: "No courses scheduled for this period.",
        NoCoursesForSearch: "No courses returned based on your search.",
        NoCoursesForSessionOrDate: "There are no courses for your selected filters.",
        NoCoursesToShow: "No Courses to Show",
        NoElectronicAddresses: "No Electronic Addresses",
        NoEmergencyContacts: "No Emergency Contacts",
        NoEmployersAdded: "No Employers Added",
        NoEmploymentInformationEntered: "No Employer Information Entered",
        NoEnrollments: "No Enrollments",
        NoEnrollmentsForStudent: "There are no enrollments available for this student",
        NoEnrolments: 'No Enrolments',
        NoFinancialAid: "No Financial Aid Applies",
        NoGMATScoresAdded: "No GMAT Scores Added",
        NoGREScoresAdded: "No GRE Scores Added",
        NoHighSchoolInformationEntered: "No High School Information Entered",
        NoHighSchoolsAddred: "No High Schools Added",
        NoHolds: "No Holds",
        NoInvoicesToShow: "No Invoices to show",
        NoKnownDisability: 'No known disability',
        NoLanguagesAdded: "No Languages Added",
        NoMembershipsToShow: "No Memberships to show",
        NoMessagesOrAlerts: "No messages or alerts.",
        NoPhoneNumbers: "No Phone Numbers",
        NoPraxisIIScoresAdded: "No PRAXIS II Scores Added",
        NoPraxisScoresAdded: "No PRAXIS Scores Added",
        NoTransactions: "You have no transactions.",
        NoQualificationInformationEntered: "No Qualification Information Entered",
        NoQualificationsAdded: "No Qualifications Added",
        NoSATScoresAdded: "No SAT Scores Added",
        NoScheduleForCourse: "No Schedules for this course",
        NoSpecialismsAdded: "No Specialisms Added",
        NoStudentsToShow: "No Students to Show",
        NoSubscoresRecorded: "No Sub-scores Recorded",
        NotAllStepsComplete: "There are steps not completed.  Please review and complete all required fields",
        NotAuthorizedToViewPage: "You are not authorized to view this page.  Please log in and try again.",
        NoTOEFLScoresAdded: "No TOEFL Scores Added",
        NoTransactionsToShow: "No Transactions to Show",
        Number: "Number",
        NumberMustBeBetweenZeroAndAmount: "The value must be greater than or equal to 0.01 and less than or equal to the amount entered in the Original Amount field.",
        NumberOfBeneficiaries: "Beneficiaries",
        NumberOfInstallments: "Number Of Installments",
        NationalInsuranceNumber: "National Insurance Number",
        Occupation: "Occupation",
        OK: "OK",
        OfferedIn: "Offered In:",
        OfficialTranscriptCharge : "The current charge set for purchasing the transcript is: {0}",
        OfficialTranscriptVery: "The Official Transcript may be different than the Unofficial Transcript.",
        OneProgramRequired: "At least one program is required.",
        OneTimeFees: "One Time Fees",
        OnlinePortfolioText: 'Online Portfolio',
        OnlinePortfolioTitle: 'Portfolio URL',
        OnlinePortfolioGuidanceText01: 'Art, Design, Media students applying for creative studio based courses, please include a URL link to your online portfolio here that should contain a selection of up to 20 images or 10 minutes of video of your past work. You should also explain how you would like to develop your practice during your course of study.',
	    OnlinePortfolioGuidanceText02: 'If you are unable to provide a URL at this point, you can still complete your application; however you will need to provide it before we can offer you a place and we will be in touch to tell you where to send your URL in that case.',
        OriginalAmount: "Original Amount",
        Other: "Other",
        OtherQualificationType: 'Other Qualification Type',
        OutstandingBalance: "Outstanding Balance",
        Overall: "Overall",
        OverallGrade: "Overall Grade",
        OverallScore: "Overall Score",
        Overdue: "Overdue",
        PackageTotals: "Package Totals",
        PageLegend_0OfTotal1Pages: "\u003cspan\u003e{0}\u003cspan class=\"notPhone\"\u003e of total \u003c/span\u003e\u003cspan class=\"isPhone\"\u003e/\u003c/span\u003e{1}\u003cspan class=\"notPhone\"\u003e Pages \u003c/span\u003e\u003c/span\u003e",
        PageLegend_0OfTotal1PagesTotalCount2: "{0} of Total {1} Pages Total Count: {2}",
        PageLegend_Showing0Thru1Of2: "\u003cspan\u003e\u003cspan class=\"notPhone\"\u003eShowing {0} - \u003c/span\u003e\u003cspan class=\"isPhone\"\u003e{0} - \u003c/span\u003e{1}\u003cspan class=\"notPhone\"\u003e of \u003c/span\u003e\u003cspan class=\"isPhone\"\u003e / \u003c/span\u003e{2}\u003c/span\u003e",
        Pages: "Pages",
        Paid: "Paid",
        PartialApplicationInProgress_Question: "You have partial applications in progress. Would you like to load one of them?",
        PartialApplicationInProgress_QuestionText: 'You have partial applications in progress. Select from the list below to continue one of them or <span role="link" tabindex="0" class="smPartialNewApplication smModalClose" style="float:none;display:inline;margin:0;">start a new application</span>.',
        PartialApplications: "Partial Applications",
        PassingScore: "Passing Score",
        PassportExpiration: "Passport Expiry Date",
        PassportIssueDate: 'Passport Issue Date',
        PassportIssuePlace: "Passport Place of Issue",
        PassportNumber: "Passport Number",
        Password: "Password",
        PasswordsDoNoMatch: "The password and confirmation password values do not match.",
        PayableNow: "Payable Now",
        PayableNowFallDue: "Payable Now / Fall Due",
        PaymentAmountHint: "The amount to be paid by the due date",
        PaymentCurrencyHint: "The currency of payment",
        PaymentDate: "Payment Date",
        PaymentDetails: "Payment Details",
        PaymentDueDateHint: "The day by which the payment must be made",
        PaymentDueAmountHint: "The total amount left to pay",
        PaymentInformation: "Payment Information",
        DepositInformation: "Deposit Information",
        PaymentMethod: "Payment Method",
        PaymentOptions: "Payment Options",
        PaymentPeriod: "Payment Period",
        PaymentPlan: "Payment Plan",
        Payments: "Payments Due",
        PaymentSuccessful: "Payment Successful",
        PaymentStatusHint: "Additional information",
        Pending: "Pending",
        PendingAid: "Pending Aid",
        PendingDrop: "Pending Drop",
        PendingSponsorPayments: "Pending Sponsor Payments",
        PendingTransactionSum: "Pending",
        PendingWithdraw: "Pending Withdraw",
        PercentageSurcharge: "Percentage Surcharge",
        Period: "Period",
        PermanentAddress: "Permanent Address",
        PermanentAddress2: 'Permanent address is the same as correspondence address',
        PermanentResidentFlag: "Permanent Resident Flag",
        StatusInCanada: "Status in Canada",
        Person0RequestsReUploadOf1: "{0} requests re-upload of {1}",
        Personal: "Personal",
        PersonalDetails: "Personal Details",
        PersonalInformation: "Personal Information",
        PersonalStatement: "Personal Statement",
        PersonalStatementText: 'Please provide a personal statement that sets out your reasons for undertaking the programme.  Admissions tutors will be interested in the reasons for your choice of programme, your career aspirations, and relevant experience and information concerning your intellectual, social, sporting or other interests.  You should also give details of any non-examined subjects you are studying.  If you have been out of education for some time, please outline any relevant experience that you would like to be taken into account in lieu of formal qualifications, either at home or in voluntary or paid work. Please keep your statement within 4000 characters.',
        PersonalStatementMore: 'We recommend you have your personal statement prepared in a separate document so you can copy and paste this into the personal statement field on the application form.',
        PhoneCarrier: "Phone Carrier",
        PhoneNumber: "Phone Number",
        PhoneNumber_Abb: "Phone #",
        PhoneNumbers: "Phone Numbers",
        PhoneRenderingHere: "Phone Rendering Here",
        PickCountryAndTemplate: "Please select a Country and a Template",
        PlaneGeometryAndTrig: "Plane Geometry/Trig.",
        PleaseWait: "Please wait...",
        POBox: 'PO Box',
        PostCodeToolTip: 'If you are inputting a UK address and don’t know the postcode, you can use the <a target="_blank" href="http://www.postoffice.co.uk/postcode-finder">Post Office’s Postcode finder service (Opens in new tab)</a>.',
        PostZipCode: "Postcode/ZIP Code",
        Points_Abb: "PTS",
        PostalCode: "Postal Code",
        Posted: "Posted",
        PraxisIITest: "Praxis II Test",
        PraxisIITestDate: "Praxis II Test Date",
        PraxisScores: "PRAXIS Scores",
        PraxisScoresII: "PRAXIS II Scores",
        PraxisTest: "Praxis Test",
        PraxisTestDate: "Praxis Test Date",
        PreAndElementaryAlgebra: "Pre-Alg./Elementary Algebra",
        Preenrollment: "Pre-Enrollment",
        PreenrollmentConfirmationCancel: "Are you sure you want to cancel this pre-enrollment?",
        PreenrollmentConfirmationCancelled: "Your course selections for this pre-enrollment have been cancelled.",
        PreenrollmentConfirmationSubmit: "Are you sure you want to submit this pre-enrollment?",
        PreenrollmentConfirmationSubmitted: "Thank you for submitting your course selections for this pre-enrollment.",
        PreferredCommunicationType: "Preferred Communication Type",
        PreferredName: "Preferred Name",
        PreferredNameText: 'Preferred Name (if different from above)',
        Present: "Present",
        Previous: "Previous",
        Previous_Abb: "Prev",
        PreviousBalance: "Previous Balance",
        PreviousCollege: "Previous College",
        PreviousGrade: "Previous Grade",
        PreviouslyBeenGranted: 'Have you previously been granted a visa to study in the UK?',
        PreviousGrade_Abb: "Prev.",
        PreviousPage: "Previous Page",
        PrimaryEFC: "Primary EFC",
        PrimaryLanguage: "Primary Language",
        PrimaryLanguageChecked:"Set as Primary Language checked",
        PrimaryLanguageNotChecked:"Set as Primary Language not checked",
        PrimaryPhone: "Primary Phone",
        PrimaryPhoneNumber: "Primary Phone #",
        PrimaryPhoneNumberInfo: 'Primary Phone Number (include country code)',
        PrimaryAddressUpdationWarning: 'At least one primary electronic address is required!',
        PrincipalDetails: "Payment Plan Items",
        Print: "Print",
        PrintedOn: "Printed On",
        Proceed: "Proceed",
        Processing: "Processing",
        ProcessingTransactionSum: "Processing",
        ProcessRegistration: "Process Registration",
        ProcessTermsConditions: "Process Terms & Conditions",
        Professor: "Professor",
        Proficiency: "Proficiency",
        ProficiencyAwaytingTooltip: "If you are awaiting confirmation of your overall grade, please tick 'Awaiting Result'",
        ProficiencyTooltip: 'If you have completed this qualification please enter the overall grade you achieved',
        ProfileImage: "Profile Image",
        Program: "Program",
        ProgramCurriculam: "Program Curriculum",
        ProgrammeCategory: 'Programme Category',
        ProgrammeChoice: 'Programme Choice',
        Province: "Province/State",
        Purchase: "Purchase",
        PurcahseOfficialTranscriptHeader: "Purchase Official Transcript",
        PurchaseOfficialTranscriptMessage: "By pressing 'Yes', you are agreeing to be charged {0} for the purchase of this transcript.",
        Qualification: "Qualification",
        QualificationGrade: "Qualification Grade",
        Qualifications: "Qualifications",
        QualificationsP1: 'Please provide details of qualifications you have achieved or are expecting to achieve. If you are applying for postgraduate study, please provide only the most relevant qualification (e.g. first degree/professional qualifications). If applying for undergraduate study we require details of GCSE/Level 2 and A-level/Level 3 qualifications.',
        QualificationsP2: "For each qualification, click 'Add Qualification' to add them to the list. If you wish to update or delete a qualification, click on the relevant option for the qualification listed.",
        QualificationSitting: "Qualification Sitting",
        QualificationsObtained: "Qualification Obtained",
        QualificationSub: 'Please select the subject you studied or choose the nearest equivalent if you cannot find an exact match.',
        QualificationSubject: "Qualification Subject",
        QualificationType: "Qualification Type",
        QualificationTypeOptions: 'Qualification Type Options',
        QualificationYear: "Qualification Year",
        QualificationYearCompleted: 'Year Completed',
        QualificationYearMax: "Qualification Year cannot be greater than 9999.",
        QualificationYearMin: "Qualification Year cannot be less than 1930.",
        Quantitative: "Quantitative",
        Reading: "Reading",
        ReadingScore: "Reading Score",
        ReadingSubScores: "Reading Sub-Scores",
        ReasonForStaffChange: "Reason for Change of Professor",
        ReassessedGrade: "Reassessed Grade",
        ReassessedFinalGrade: "Reassessed Final Grade",
        ReassessedGradeType: "Reassessed Grade Type",
        RecordAllAttendanceAs0_Question: "Are you sure you wish to record all as {0}?  This will set all student attendance that have not yet been set.",
        Recorded: "Recorded",
        Recurring: "Recurring",
        Reenrollment: "Re-Enrollment",
        ReenrollmentConfirmationCancel: "Are you sure you want to cancel this re-enrollment?",
        ReenrollmentConfirmationCancelled: "Your course selections for this re-enrollment have been cancelled.",
        ReenrollmentConfirmationSubmit: "Are you sure you want to submit this re-enrollment?",
        ReenrollmentConfirmationSubmitted: "Thank you for submitting your course selections for this re-enrollment.",
        ReenrollmentCanRegisterNotActive: "Re-Enrollment is not available, please contact your administrator.",
        Reference: "Reference",
        Register: "Register",
        RegisteredCourses: "Registered Courses",
        Registration: "Registration",
        RegistrationAlert: "Registration Alert",
        RegistrationMilestone: "Registration Milestone",
        CoursePlanningRegistrationMilestone: "Course Selection",
        RegistrationMilestoneMessage: "The registration period has ended, you cannot register.",
        RegistrationCanRegisterNotActive: "Registration is not available, please contact your administrator.",
        RegistrationNumber: "Registration Number",
        RegistrationPreview: "Registration Preview",
        RegistrationSuccessful: "Registration Completed Successfully",
        Relationships: "Relationships",
        Relationship: "Relationship",
        PrimaryContactNumber: "Primary Contact Number",
        SecondaryContactNumber: "Secondary Contact Number",
        Primary: "Primary",
        Religion: "Religion",
        Remaining: "Remaining",
        RemainingCharacters: 'Remaining characters',
        RemainingNeed: "Remaining Need",
        Remove: "Remove",
        RemoveCourse: "Remove Course from the list",
        RemoveCourseTooltip: "Remove Course",
        Reply: "Reply",
        RequestDocuments: "Request Documents",
        RequestInformationEntryPoint: "From which level would you like to start your education?",
        RequestReUpload: "Request Re-Upload",
        RequestReUploadSent: "Your Request to Re-Upload Has Been Sent",
        RequireCreateAnAccountApplicationAlreadyHaveOne0_Question: "In order for us to communicate with you and process your application properly, please create an account.  Already have an account? {0}",
        RequireCreateAnAccountInquiryAlreadyHaveOne0_Question: "In order for us to communicate with you and process your inquiry properly, please create an account. Already have an account? {0}",
        Required: "Required",
        RequiredBy0: "Required by: {0}",
        RequiredByDegree: "Required By Degree",
        RequiredDocuments: "Required Documents",
        RequiredVisa: 'Do you require a visa to study in the UK?',
        Requirements: "Requirements",
        RequireTheFollowingToCompleteAdmission: "We require the following in order to complete your Admission.",
        RequireTheFollowingToCompleteAdmissionText: 'We require the following in order to consider your application.',
        RequisiteType: "Requisite Type",
        ResidentCountry: 'Country of Permanent Residence',
        ReservedCourses: "Reserved Courses",
        Reserved: "Reserved",
        Waitlisted: "Wait-listed",
        Reset: "Reset",
        ResetAllStatuses_Question: "Are you sure you wish to reset all recorded statuses?",
        ResidentState: "Resident State",
        Restriction: "Restriction",
        Review: "Review",
        ReviewAndSubmit: "Review \u0026 Submit",
        ReviewDataClickSubmit: 'Please review all the data and if everything looks correct, click the \"Submit My Application\" button below.',
        ReviewYourApplicantChecklist: "Review your Applicant Checklist",
        RhetoricalSkills: "Rhetorical Skills",
        Room: "Room",
        RoomDetails: "Room Details",
        RoomNumber: 'Room/House Number',
        RoomNumberInfo: 'Room Number',
        Roster: "Roster",
        Rule: "Rule",
        SalutationTooltip: 'Please select how you wish to be addressed in letters and other communications.',
        SATScores: "SAT Scores",
        SATTestDate: "SAT Test Date",
        Save: "Save",
        Saved: "Saved",
        Scale: "Scale",
        Scenario: "Scenario",
        Schedule: "Schedule",
        ScheduleAndFees: "Schedule And Fees",
        ScheduleConflict: "Schedule Conflict",
        ScheduleDetails: "Schedule Details",
        Schedules: "Schedules",
        Science: "Science",
        Score: "Score",
        Search: "Search",
        Seats: "Seats",
        Section: "Section",
        SectionRegistered: "This section has been registered.",
        SectionReserved: "This section has been reserved.",
        Select: "Select",
        SelectCountryAndAddressFormat: "Please select a Country and an Address Format.",
        SelectOne: "Select One",
        SelectOneorMore: "Select One or More",
        SelectPaymentPlan: "Select Payment Plan",
        SelectPeriodBeforeSearch: "Please select at least a Period before searching.",
        SelectToPay: "Please select to Pay",
        Self: "Self",
        Send: "Send",
        SendingMessage: "Sending Message...",
        Sent: "Sent",
        ServerError: "Server Error",
        Session: "Session",
        Set: "Set",
        Settings: "Settings",
        SexualOrientation: "Sexual Orientation",
        SinglePrimaryEmailDelete: 'To delete this email address, please make another email address your contact preference first',
        SinglePrimaryPhoneDelete: 'To delete this phone number, please make another number your contact preference first',
        SinglePrimaryAddressDelete: 'To delete this address, please make another address your contact preference first',
        Showing0to1of2: "Showing {0} to {1} of {2}",
        ShowOnDirectory: "Show on Directory",
        SkypeAddress: "Skype address",
        SkypeNameOrEmail: "Skype Name or Email",
        SocialMedia: "Social Media",
        SocialStudiesAndSciences: "Social Studies/Sciences",
        SpeakingScore: "Speaking Score",
        Specialism: "Specialism",
        SpecialismCategory: "Specialism Category",
        Sponsor: "Sponsor",
        SponsorNameHeader: "Sponsor:",
        SponsorContributionHeader:"Sponsor Contribution:",
        SponsorVerificationHeader:"Is Verified?",
        EmptyAmountinMultiPaymentSelection: "All selected payment methods require a value corresponding to the amount being paid via each method",
        HigherAmountinMultiPaymentSelection:"The amount entered cannot be higher than the total billed amount",
        LowerAmountinMultiPaymentSelection:"The amount entered cannot be lower than the total billed amount",
        AddNewSponsors:"Add New Sponsors:",
        SponsorNotes:"Sponsor Notes",
        SponsorNotesMessage:"Maximum limit: 255 characters",
        UploadVerificationLetter:" Upload Verification Letter",
        UploadLetterMessage:"Upload Verification of Sponsorship. All documents loaded here will be available on your Financial Account Repository.",
        SponsorContributionErrorMessage:"Amount max value: 9,999,999,999,999 / Percentage must be between 0 to 100",
		SponsorErrorMsgForPercent:"Percentage must be between 0 to 100",
        SponsorErrorMsgForMoney:"Amount max value: 9,999,999,999,999",
        SponsorNameNotExist: "This sponsor does not exists",
        SponsorAlreadyExist: "This sponsor already exists",
		SponsorDocAlreadyUploaded: "This document has already been uploaded",
        SponsorDocUploadValidationMsg: "Unsupported file type. Please choose from one of the following: .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .xlsm, .ppt, .pptx, .txt",
        SponsorPageMessage:"Please review your Sponsorship. If you need to add a new sponsor, select Sponsorship information below. If your sponsor doesn not exist, please contact the finance office. All information must be verified by your institution prior to adding the Sponsor on your account. Please upload a verification letter.",
        SponsorsApprovalDescription: "Sponsor must be approved to see your financial data.",
        SponsorRequiresVerification: "Any sponsor(s) must be verified before submitting this registration form. If your sponsor is not verified, please contact the Student Finance team.",
        SponsorVerificationValueVerified: "Yes",
        SponsorVerificationValueUnverified: "No",
        ConfirmCancellingSponsorDetails: "Are you sure you want to cancel submitting the sponsor details?",
        ConfirmSubmittingSponsorDetails:"Do you want to submit the sponsor details?",
        SuccessfulEditSponsorDetailsMessage: "Thank you for submitting additional information on your sponsor.",
        SuccessfulSponsorSubmissionMessage: "Thank you for submitting your sponsor details.",
        UnsuccessfulSponsorSubmissionMessage: "There was an error while trying to submit your sponsor details. Please contact your administrator",
        StartApplicationLogInNewPassword: "If you\u0027d like to go ahead and start the Application now, click the link below.  Assuming the system has had time to process your inquiry, the first thing you\u0027ll need to do is verify your email and change your password.  Once your password has been changed, you\u0027ll be logged in and we will try to populate as much data as we can from your inquiry.",
        StartApplicationPrePopulateData: "If you\u0027d like to go ahead and start the Application now, click the link below.  Assuming the system has had time to process your inquiry, your generated user-name will be pre-populated. \u003c/br\u003eUse the password you provided to log in, and we will try to populate as much data as we can from your inquiry.",
        StartDate: "Start Date",
        State: "State",
        Statement: "Statement",
        Statements: "Statements",
        Status: "Status",
        WaitlistRank: "Waitlist Rank",
        StepLegend0: "(Step {0})",
        StudentAverages: "Student Averages",
        StudentBirthdate: "Student Birthdate",
        StudentID: "Student ID",
        StudentIDText: 'Please provide your Manchester Met student ID number if you still know it',
        StudentName: "Student Name",
        StudentTranscript: "Student Transcript",
        Subject: "Subject",
        SubmissionDate: "Submission Date",
        Submit: "Submit",
        SubmitApplication0AndInstructions: "Thank you for submitting your application, {0}!  Continue on to review your applicant checklist.",
        SubmitApplication0WithReceiptAndInstructions: "Thank you for submitting your application, {0}!  You can download a receipt of your transaction below, then continue on to review your applicant checklist.",
        SubmitApplicationReceiptAndInstructions:"Thank you for providing your application information. In order for us to process your application please continue to the applicant checklist, where you can review and upload any required documents.",
        SubmitGrades: "Submit Grades",
        SubmitMyApplication: "Submit My Application",
        Submitted: "Submitted",
        Submitting: "Submitting...",
        Subscores: "Sub-scores",
        Success: "Success",
        Summary: "Summary",
        SummaryInfoMessageH2: '<h2>You are about to submit stage 1 of your application.</h2><br/>',
        SummaryInfoMessage: "<p style='padding:0 0 5px;'> To complete your full application, you need to submit both stages of the application process.</p><p style='padding:0 0 5px;'> Stage 2 is completion of your portfolio. This is done in a system called “PebblePad”. You will receive an email with your account details and instructions shortly. Please review all the data you have provided for Stage 1 to check it is correct. Then click the “Submit my Application” button below.</p>",
        Tax: "Tax",
        TaxAmount: "Tax Amount",
        TaxCode: "Tax Code",
        TaxID: "Social Security Number",
        TaxIDDisplayFormat: "###-##-####",
        TaxIDRegularExpression: "^(\\d{3}-|\\*\\*\\*-)(\\d{2}-|\\*\\*-)(\\d{4})$",
        TaxRate: "Tax Rate",
        Template: "Template",
        Term: "Term",
        TermAndDates: "Term / Dates",
        TermDatesRoom: "Term/Dates/Room",
        TermsConditions: "Terms & Conditions",
        TermsConditionsNeedToBeAccepted: "Terms & Conditions need to be accepted",
        TermsNotAccepted: "Please accept required Terms & Conditions",
        TestDate: "Test Date",
        TestDate0: "Test Date - {0}",
        TestName: "Test Name",
        TestScores: "Test Scores",
        TestScoresOnFileForReview: "Below are the test scores that we have on file for you.  Please review them and let us know if you find any errors.",
        ThankYouForSubmittingInquiry0: "Thank you for submitting your inquiry, {0}!",
        ThereWasAnError: "There was an error",
        ThirdParty: "Third Party",
        ThisTermChangedMsg: "New version of paragraph",
        Title: "Title",
        To: "To",
        TOEFLScores: "TOEFL Scores",
        TOEFLTest: "TOEFL Test",
        TOEFLTestDate: "TOEFL Test Date",
        ToggleButton: "Toggle Button",
        Total: "Total",
        Total0Completed: "Total {0} Completed",
        TotalAmount: 'Total Amount',
        TotalAttempted: "Total Attempted",
        TotalAwards: "Total Awards",
        TotalBalance: "Total Balance",
        TotalOverall: "Total Overall",
        TotalPending: "Total Pending",
        TotalPosted: "Total Posted",
        TotalProcessing: "Total Processing",
        TownCity: 'Town/City',
        TransactionAmount: "Transaction Amount",
        TransactionDate: "Transaction Date",
        TransactionDate_Abb: "Trans Date",
        TransactionDescription: "Transaction Description",
        TransactionDetails: "Transaction Details",
        TransactionFor: "Transaction For",
        TransactionPayer: "Transaction Payer",
        Transactions: "Transactions",
        Transfer: "Transfer",
        TotalPrincipal: "Total Principal",
        TS_0TestDetails: "{0} Test Details",
        Type: "Type",
        TypeOfAdmissions: "Type of Admissions",
        TypeToSearch: "Type to search...",
        TypeToSearchText: 'Start typing a postcode or address',
        UnArchive: "Un-Archive",
        UnArchiveButton: "Unarchive",
        UnAuthorized: "Un-Authorized",
        UniqueUserNameGeneratedOnApplication: "Your unique user name will be emailed to you once the application is partially saved or submitted.",
        UniqueUserNameGeneratedOnInquiry: "Your unique user name will be emailed to you once the inquiry is submitted.",
        UnknownError: "Unknown Error",
        UnmetCoRequisites: "Unmet CoRequisites",
        UnmetRequisites: "Unmet Requisites",
        UnmetPreRequisites: "Unmet PreRequisites",
        UnmetHighSchoolCourseRequisite: "Unmet High School Course Requisites",
        Unread: "Unread",
        UnreadMessages: "Unread Messages",
        UnsupportedFileTypesInformation: "Unsupported file type. Use one of types:",
        UnverifiedOrganisation: 'Unverified Organisation',
        Uploading: "Uploading...",
        UploadDocumentValidation: "All document widgets must have at least one document uploaded and the document type selected",
        UploadDocumentValidationGenericForm: "This document widget must have at least one document uploaded.",
        UploadProfilePhoto: "Upload Profile Photo",
        UploadDocument: "Upload Document",
        UploadTranscript: "Upload Transcript",
        UploadProfilePhoto: "Upload Profile Photo",
        UploadSuccessful: "Upload successful",
        UsageAndMechanics: "Usage/Mechanics",
        UseAddress: "Use Address",
        UseCorrespondenceAddress: "Use Correspondence Address",
        UseMailingAddress: "Use Mailing Address",
        UserName: "User Name",
        UsingAdvancedSearch: "Using Advanced Search...",
		Upload: "Upload",
        UnverifiedOrganisation: 'Unverified Organisation',
        Validate_0CharactersOrLess: "Value must have {0} characters or less.",
        Validate_0CharactersOrLessFlexi: "The field value must be less than or equal to {0} characters long.",
        Validate_GreaterThanEqual0Flexi: "The field value must be more than or equal to {0}.",
        Validate_LessThanEqual0Flexi: "The field value must be less than or equal to {0}.",
        Validate_Number_Range_Flexi: "The field value must be between {0}",
        Validate_MustBeNumeric_Flexi: "The field value must be numeric.",
        Validate_MustBeInteger_Flexi: "The field value must be without a fractional component.",
        Validate_MustBeADate_Flexi: "Value must be a valid date.",
        Validate_ErrorInFormat0: "Value must be in format {0}",
        Validate_FieldRequired: "This field is required.",
        Validate_GreaterThan0: "Value must be greater than {0}",
        Validate_GreaterOrEqualThan0: "Value must be greater or equal than {0}",
        Validate_IncorrectFormat: "Invalid Format",
        Validate_LessThan0: "Value must be less than {0}",
        Validate_LessOrEqualThan0: "Value must be less or equal than {0}",
        Validate_MinimumOneEmergencyContact: "There has to be at least one Emergency Contact!",
        Validate_MustBeADate: "Value must be a date",
        Validate_MustBeNumeric: "Value must be numeric",
        Validate_GpaMustBeLessOrEqual: "GPA value must be less or equal {0}",
        Validate_GpaMustBeBiggerOrEqual: "GPA value must be bigger or equal {0}",
        Validate_GpaScaleMustBeLessOrEqual: "GPA Scale value must be less or equal {0}",
        Validate_GpaScaleMustBeBiggerOrEqual: "GPA scale value must be bigger or equal {0}",
        Validate_Decimals: "The value must have no more than {0} decimal places.",
        Validate_ItsNotAValidPhoneNumber: "This is not a valid phone number.",
        Validate_MustBeProperDateOfBirth: "The date must be between 1900 and the current date",
        Validate_Numbers_and_Special_Characters: 'Value must be alphabetical',
        Validate_minimumCharacters: 'Phone number not valid',
        Validate_PhoneNumber:"Value must be a valid telephone number format.",
        Validate_UKZipCode: "Value must be a valid UK zip code",
        Validate_USZipCode: 'Value must be a valid US code',
        ValidationErrors: "Validation Errors",
        ValidationMsgForFileFilterUpload: "Unsupported file type. Use one of types: .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .xlsm, .csv, .ppt, .pptx, .txt, .gif, .tif, .tiff, .bmp, .wmv, .mp4, .mpg, .mpeg, .mp3, .wav",
        Validations: "Validations",
        Validate_Alphanumeric: "Invalid input. Use only alphanumeric characters.",
        Verbal: "Verbal",
        VerificationQuestionDoesNotMatchAnswer: "Verification Question does not match expected answer.",
        VerificationLetter: "Verification Letter",
        Veteran: "Veteran",
        ViewBy: "View By",
        VisaExpirationDate: "Visa Expiration Date",
        VisaNumber: "Visa Number",
        VisaType: "Visa Type",
        VoidReason: "Void Reason",
        VoidUser: "Void User",
        WaitlistedCourses: "Waitlisted Courses",
        Warning: "Warning",
        WeChatID: 'WeChat ID',
        WeChatFormat: 'Value must be in WeChat format.',
        WeChatTooltip: 'Please provide your WeChat ID if you are in China so we can contact you by this method if necessary.',
        WelcomeBack0Prefilled: "Welcome back, {0}.  Your personal information has been pre-filled, but may be changed.",
        WithdrawAlert: "Withdraw Alert",
        WithdrawFailed: "Withdraw Failed",
        WithdrawFailedTryAgain: "Withdraw Failed, Try Again",
        WithdrawFromCourse: "Withdraw From Course",
        WithdrawnDate: "Withdrawn Date",
        Writing: "Writing",
        WritingScore: "Writing Score",
        Yes: "Yes",
        Year: "Year",
        YouAreNowLoggedIn:"You are now logged into our system.",
        YouHave0RequiredTermsConditionsToAccept: "You have {0} required Terms & Conditions to accept",
        YouHaveNoSponsors: "You have no sponsors.",
        YouHaveNoTransactions: "You have no transactions.",
        YouHave0PendingChanges: "You have {0} pending changes that will be lost. Waitlisted courses will not be lost if processed previously",
        Validate_DuplicateEmail: "The e-mail address already exists.",
        StudentAcceptance: "Student Acceptance",
        ReadyToCreateUser: "We are ready to create a user account for you. If you continue with your application, we will log you into our system.",
        Reject: "Reject",
        Rejected: "Rejected",
        ProcessStatus: "Process Status",
        OriginationFeePercent: "Origination Fee",
        NoDataToShow: "No Data to Show",
        InterestRebatePercent: "Interest Rebate",
        DisbursementDate: "Disbursement Date",
        BillingTransactionDate: "Billing Transaction Date",
        Anticipated: "Anticipated",
        Actual: "Actual",
        StudentIdIsntAssignedToThisStudentAcademicRecordId: "Student isn't assigned to student academic record choosen",
        HoldActive: "There is an active hold for You and You can't continue with current operation",
        MustAcceptTermsConditions: "Before accepting, rejecting or modifying an Award you must accept \"Terms & Conditions\".",
        ReenrollmentSubmitted: "Thank you for submitting your re-enrollment. Your request was processed successfully.",
        ReenrollmentMakePaymentSubmitted: "Chosen payment method requires confirmation. Please, make payment and wait for the confirmation.",
        GetShoppingSheet: "Get Shopping Sheet",
        GetAwardLetter: "Get Award Letter",
        GetCollegeFinancingPlan: "Get College Financing Plan",
        SponsorInvoices: "Sponsor Invoices",
        Invoice: "Invoice",
        KnownDisability: 'If you have answered \'Yes\' and added details of any disabilities or special needs and wish to change your answer back to \'No known disability\', please remove the disabilities or special needs listed below first',
        NoInstallmentsToShow: "No Installments to show",
        NoOneTimeFeesToShow : "No One Time Fees to show",
        NoSponsorInvoicesToShow: "No Sponsor Invoices To Show",
        NoPaymentPlansToShow: "No Payment Plans to Show",
        NoPrincipalDetailsToShow: "No Payment Plan Items to show",
        Void: "Void",
        SelectAllPayments: "Select all",
        NoPaymentsSelectedOrMoreThanOneCurrencySelected: 'No payments selected or more than one currency selected',
        YouCanPayForOneBeneficiaryAtOnce: 'You can pay for one beneficiary at once',
        FormSubmitted: "Thank you for submitting your personal FORM. Your request was processed successfully.",
        FormSendingSuccessful: "Sending successful!",
        SatisfactoryAcademicProgress: "Satisfactory Academic Progress",
        BaseAcademicPeriod: "Base Academic Period",
        SAPStatus: "SAP Status",
        FileRequired: "File is required.",
        TransactionProcessing: "Please wait, your transaction is being processed.",
        TransactionStatusUnknown: "Transaction processing time is extended, please check status in My Account later.",
        ResponseAuthorised: "Thank you, your payment was processed successfully.",
        ResponseInitiated: "Your payment has been initiated. Please check the status in My Account once completed.",
        ResponseCancelled: "Transaction was canceled, please try again.",
        ResponseError: "Transaction failed, please try again.",
        PaymentAmount: "Amount",
        PaymentCurrency: "Currency",
        PaymentStatus: "Payment Status",
        PaymentPlans : "Payment Plans",
        Alert: "Alert",
        ThereAreOlderPaymentsThanSelectedTurnOfFilters: "There are older payments than selected. Turn off filters, please.",
        ReviewerComment: "Reviewer Comment",
        PreenrollmentNotAvailable: "Sorry, Pre-enrollment is not available now.",
        PreenrollmentTermsAndConditionsNotAccepted: "Terms & Conditions have to be accepted to access pre-enrollment.",
        RegistrationNotAvailable: "Sorry, Registration is not available now.",
        ReEnrollmentNotAvailable: "Sorry, Re-Enrollment is not available now.",
        PreenrollmentTermsAndConditions: "Please accept required Terms and Conditions. Accessing Pre-Enrollment is only possible when all mandatory points are accepted.",
        ActionDate: "Action Date",
        ModifyAwardAmountButtonStandardTooltipText: "Modify the Award amount.",
        ModifyAwardAmountButtonAwardAcceptedOrRejectedTooltipText: "This Award has already been accepted / rejected. The amount cannot be modified.",
        ModifyAwardAmountCancelButtonTooltipText: "Cancels the changes made on the Amount of the Award.",
        ModifyAwardAmountSaveButtonTooltipText: "Saves the changes made on the Amount of the Award.",
        SIN: "Social Insurance Number",
        CanadaSIN: "SIN",
        ASN: "Alberta Student Number",
        SelectProvincialTerritorialNumbers: "Select Provincial / Territorial Student Number",
        DuplicateProvincialBMNEntry: "An ID number has already been entered for this Province / Territory / Organization.",
        EntryDateIntoCanada: "Entry Date into Canada",
        WorkPermitNumber: "Work Permit Number",
        WorkPermitExpirationDate: "Work Permit Expiration Date",
        StudyPermitNumber: "Study Permit Number",
        StudyPermitExpirationDate: "Study Permit Expiration Date",
        PermitNumberValidationMessage: "Value can only contain numbers, letters, hyphens, and spaces.",
        CountryPrefixCode: "Country Calling Code",
        AreaCityCode: "Area City Code",
        FinancialAidRemoveDocumentNote: "Note: Financial Aid documents can not be removed via the Student Portal. Please contact an administrator to make amendments.",
        DiscountCode: "Discount Code",
        DiscountName: "Discount Name",
        DiscountType: "Discount Type",
        DiscountValue: "Discount Value",
        DisplayInformation: "Display Information",
        PersonalDiscountCodes: "Personal Discount Codes",
        ClickRecalculate: "Click Recalculate to see the amount to pay",
        MainBarPaymentNameSelected: "Payment method: {0}",
        NotSelected: "not selected",
        ChosenPaymentMethodRequiresConfirmation: "Chosen payment method requires confirmation. Please, make payment and wait for the confirmation.",
        AcademicStartPeriod: "Academic Start Period",
        CurrentlyViewingOnPortalToolTip: "Academic Record marked as View On Portal, will be used in Registration and Degree Audit.",
        SARSWidgetTitle: "Student Academic Records",
        SelectingViewOnPortalToolTip: "Selecting this Academic Record as View On Portal will use it in Registration and Degree Audit.",
        View: "View",
        NoSchedulesFound: "No Schedules Found",
        NoAcademicRecords: "No Academic Records",
        ViewOnPortal: "Currently Viewing on Portal",
        NoDocumentstoDisplay: "No Documents to Display",
        MilestonesRemaining: "Total Milestones Remaining",
        MinimumMilestones: "Minimum Milestones Required",
        From0To1: "From {0} to {1}",
        VariableCreditHoursErrorMessage: "Please select value from {0} to {1}.",
        TaxDetails: "Tax Details",
        BaseNet: "Base Net",
        TransferFrom: "Transfer From",
        LocationOfCompletion: "Location of Completion",
        Complete: "Complete",
        DateOfCompletion: "Date of Completion",
        AuthorizingEntity: "Authorizing Entity",
        DocumentRepositoryType: "Document Repository Type",
        Source: "Source",
        Comments: "Comments",
        UsedForPlacement: "Used for Placement",
        MilestoneScore: "Score/Marks",
        AdministeredBy: "Administered By",
        NoCoursesInPeriodForBlock: "This period doesn\u0027t have courses from your registration blocks. You can proceed to register to other courses.",
        AnnualStudentLoanAcknowledgement: "Annual Student Loan Acknowledgement (ASLA)",
        FinancialAwardYear: "Financial Award Year",
        AslaReceived: "Acknowledgement Received",
        MandatoryCoursePopupTitle: "Mandatory Courses Not Selected",
        MandatoryCoursePopupMessage: "Below are the required course(s) that you have not selected for registration, however you may proceed.",
        NotRegistered: "Not Registered",
        MakePayment: "Make Payment",
        AmountRequired: "Amount cannot be empty.",
        AmountMinMaxCheck: "The amount cannot be lower than the minimum amount ({0} {1}) or higher than the selected amount due.",
        AmountMinMaxCheckForAdvancePayment: "Amount cannot be lower than the minimum amount ({0} {1}).",
        MandatoryCourseRequiredPopupMessage: "Below are the required course(s) that you have not selected for registration, kindly register them to proceed further.",
        TransactionType:"Payment For",
        EnrolmentForm: "Re-Enrollment Form",
        ChooseReenrollmentForm: "Choose re-enrollment form...",
        validate_ErrorInCityValue: "Value must be in format {0}.",
        TotalIncome: "Income Total",
        MilestoneDeadlinePassedReservedMessage: "Milestone date has passed. Course cannot be reserved.",
        TransactionFailed: 'Transaction Failed',
        EnrolInPaymentPlan: "Enrol In Payment Plan",
		ClassFullWaitlistAvailable:"The selected class has no available seats but has an open waitlist. Would you like to be added to the waitlist?",
        MyTransferCredits: "My Transfer Credits", // My Transfer Credit
        AddTransferCreditRequest: "Add Transfer Credit Request",
        SubmittedTransferCredits: "Submitted Transfer Credits",
        CompletedTransferCredits: "Completed Transfer Credits",
        TransferCreditRequest: "Transfer Credit Request",
        ProgramGoal: "Program - Goal",
        ExternalCourseInformation: "External Course Information",
        Institution: "Institution",
        ExternalCourseID: "External Course ID",
        ExternalCourseTitle: "External Course Title",
        Units: "Units",
        TransferUnitType: "Unit Type",
        Weight: "Weight",
        LetterGrade: "Letter Grade",
        NumericScore: "Numeric Score",
        DestinationCourseInformation: "Destination Course Information",
        CourseMasterID: "Course Master ID",
        CourseMasterTitle: "Course Master Title",
        CourseMasterDescription: "Course Master Description",
        TransferCreditsSummary: "Transfer Credit Summary",
        ModifiedDateRange: "Modified date range",
        PopUpCancelMsg:"Are you sure you want to cancel the Transfer Credit Request? All the saved Transfer Credits will be deleted.",
        NoTransferCreditsRequests: "No Transfer Credit Requests saved. Please add the requests using Add Transfer Credit Request window above.",
        ApproverNotes: "Approver Notes",
        PopUpEditMsg:"You have unsaved changes in the Transfer Credit Request window. Do you want to save the changes before proceeding?",
        SaveChanges:"Save Changes",
        DiscardChanges:"Discard Changes",
        PopUpSubmitMsg:"Are you sure you want to submit the Transfer Credit Request?",
        SubmittedtransferCreditRequest:"No Transfer Credits are submitted. Select Add Transfer Credit Request to create new request.",
        CompletedtransfercreditRequest:"No Transfer Credits are completed.",
        PopUpDeleteMsg:"Are you sure you want to delete the Transfer Credit Details?",
        TransferCreditDocUploadValidationMsg:"Unsupported file type. Please choose from one of the following: .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .xlsm, .ppt, .pptx, .txt",
        TransferCreditDocAlreadyUploaded: "This document has already been uploaded",
        DateModified: "Date Modified",
        UploadDocuments: "Upload Documents",
        PopUpResetMsg: "All the changes in this window will be lost, Do you want to continue?",
        SubmitSuccessMsg: "You can review the submitted Transfer Credits or add new Transfer Credit Request using options provided below.",
        RequiredFieldWarningMsg: "Please fill required fields before proceeding",
        NoTransferCreditSummary: "No Transfer Credit Summary to show",
		ClassFullWaitlistAvailable:"The selected class has no available seats but has an open waitlist. Would you like to be added to the waitlist?",
        PopupAddressTitle: "Address",
        PopupElectrnoicAddressTitle: "Electronic Address",
        MyProfilePopUpQuery: "Are you sure you want to save the changes? Editing will be disabled from portal once saved.",
        TransferCreditCopyTooltip: "Used to copy Program - Goal, Academic Period, Institution and Unit Type to the window.",
        TransferCreditEditTooltip: "Used to edit the record.",
        TransferCreditDeleteTooltip: "Used to delete the record.",
        SavedSuccessfully: "Saved Successfully",
        DeletedSuccessfully: "Deleted Successfully",
        GradeOrScoreRequired: "Letter Grade or Numeric Score is required.",
        Validate_LetterGrade: "This is not a valid Letter Grade value.",
        Validate_NumericScore: "This is not a valid Numeric Score value.",
        Validate_UnitsValue: "This is not a valid Units value.",
        Validate_UnitsMustBeLessOrEqual: "Value must have {0} characters or less.",
        UploadedDocuments: "Uploaded Documents",
        MyTransferCreditUploadFileSizeMsg: "File size more than 12 MB may take more time to save",
        ResidencyRequirementMet: "Residency Requirement Met",
        PopUpDeleteWithSaveMsg: "You have unsaved changes in the Transfer Credit Request window. Do you want to save the changes before deleting the selected record?",
        CompletedSuccessfully: "Completed Successfully",
        SubmittedTransferCreditsSummary: "Submitted Transfer Credit Summary",
        CompletedTransferCreditsSummary: "Completed Transfer Credit Summary",
        IncorrectEffectiveEndDate: "Effective End date must occur after the Effective Begin date.",
        IncorrectEffectiveBeginDate: "Effective Begin date must occur before the Effective End date.",
        AccountCreationErrorMsg: "Error In Account Creation",
        ProgramRouteDescription: "Program Route Description",
        AdmissionsProgramDescription: "Admissions Program Description",
        NoAccessibilities: "No Accessibilities",
        AcceptPopupMesg: "Are you sure you want to accept the offer?",
        DeclinePopupMesg: "Are you sure you want to decline the offer?",
        ResetFields: "Reset fields",
        ResetFieldsToolTip: "This button will only reset the fields above.",
        PayLater: "Pay Later",
        ViewReport: "View Report",
        DropDeadline: "Drop Deadline",
        WithdrawalDeadline: "Withdrawal Deadline",
        UnReserveCourseMessage: "You may not unreserve this course.",
    });
})(jQuery);
